import { ThesisSubmissionIterationStatus } from '@rdm/db'

import { thesisIterationStatuses } from './thesisIterationStatuses.js'

type RequiredStatusFields = {
  outcomeByUser?: { displayName: string }
  outcome?: ThesisSubmissionIterationStatus['outcome']
  status: ThesisSubmissionIterationStatus['status']
  outcomeMessage?: ThesisSubmissionIterationStatus['outcomeMessage']
}

export const getThesisIterationOutcomeLabel = (status: RequiredStatusFields, noOutcomeMessage = '-'): string => {
  if (!status) return 'Ready to submit'
  if (!status.outcome) return noOutcomeMessage

  if (status.outcome === 'WITHDRAWN_BY_GRADUATE') return 'Withdrawn by candidate'
  if (status.outcome === 'FAILED') return 'Submission failed'

  if (status.outcome === 'ADVANCED')
    return thesisIterationStatuses.find((s) => s.code === status.status)?.advancedMessage || 'Advanced' // Should always have outcome message..
  if (status.outcome === 'REJECTED')
    return thesisIterationStatuses.find((s) => s.code === status.status)?.rejectedMessage || 'Rejected' // Should always have outcome message..
  if (status.outcome === 'REVISE_AND_RESUBMIT') return 'Requested revise and resubmit'
  if (status.outcome === 'DOWNGRADE_TO_MPHIL') return 'Downgraded to MPhil'

  return 'Unknown'
}
